var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestQ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-65156bb5-985b-450d-9ab2-e7a415d38997",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.26 42.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.13,31.32l16.63,10.45c.78.45,1.48.4,2.18-.05l12.61-6.72,9.5,5.95v-9.16s-2.04-1.22-4.78-2.97V.98c0-.51-.43-.94-.94-.94H1.16C.65.04.22.47.22.98v28.47c0,.93.19,1.33.91,1.87Zm7.15-5.87V8.41c0-.29.24-.53.53-.53h19.87c.29,0,.53.24.53.53v15.16c-5.47-3.48-10.54-6.64-10.63-6.64v9.16l5.76,3.66-5.17,2.48c-.34.19-.77.19-1.11,0l-9.49-6.18c-.3-.2-.3-.37-.3-.61Z",
    fill: "#00f783",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestQ);
export default __webpack_public_path__ + "static/media/quest-q.3273cd9f2ae5ff6ab85f6012d1a97f86.svg";
export { ForwardRef as ReactComponent };